
<template>
    <form ref="messageRef" v-if="inboxactionMessageareaStore.events.length" class="cs_form messagearea" @submit.prevent="handleSubmit">
        <Fields
            :fields="messageFields"
            :values="messageValues"
        />
        <nav>
        <button type="submit" class="more">
            <span class="title">{{ trans("Verzenden") }}</span>
        </button>
        </nav>
    </form>
</template>

<script>
import {defineComponent, onMounted, computed, inject, ref, watch, onUnmounted, reactive} from "vue";
import {useRouter, useRoute} from "vue-router";

// Config for API urls used in this vue template
import { inboxStore, getInbox, patchInbox, clearInboxCache, updateAllCount } from "store/inbox-store";
import { inboxactionStore, inboxactionMessageareaStore, postInboxeventaction } from "store/inboxaction-store";
import { handleRead, handleUnread, routeData } from "helpers/_inbox-helpers";

import Fields from "components/fields";
import PopupConfirm from "components/popupConfirm";
import PopupHtml from "components/popupHtml";

import Icon from "components/icon";
import trans from "helpers/_translation";

export default defineComponent({
    name: "inbox-messagearea",
    components: {
        Icon,
        Fields,
        PopupConfirm,
        PopupHtml
    },
    props: {
        item: {
            type: Object,
            required: false,
            default: null
        }
    },
    setup(props) {
        const messageRef = ref();

        const addNotification = inject("addNotification");
        const isForward = computed(() => {
            return inboxactionMessageareaStore.events.some(event => event.action_type === "forwardmessage");
        });
        const isReply = computed(() => {
            return inboxactionMessageareaStore.events.some(event => event.action_type === "replymessage");
        });

        const item = computed(() => {
            return props.item;
        });
        const messageValues = computed(() => {
            const values = {};
            if (isReply.value) {
                values.email = {
                    value: item?.value?.data?.sender_uid
                };
            }
            return values;
        });
        const messageFields = computed(() => {
            // Build the fields so they can conditionally be set
            const fields = [];
            fields.push({
                "name": "email",
                "id": "email",
                "type": "TextField",
                "label": `${trans("Aan")}:`,
                "readonly": isReply.value,
                "options_json": null,
                "tooltip_information": null,
                "auto_fill": "N",
                "extra": {
                    "colclass": "span12"
                }
            });
            fields.push({
                "name": "content",
                "id": "content",
                "type": "EditorField",
                "label": trans("Uw bericht"),
                "options_json": null,
                "tooltip_information": null,
                "auto_fill": "N",
                "extra": {
                    "colclass": "span12"
                }
            });

            return fields;
        });

        watch(
            () => inboxactionMessageareaStore.events,
            (events) => {
                if (!events.length) return;

                setTimeout(() => {
                    messageRef.value && window.scrollTo({
                        behavior: 'smooth',
                        top: messageRef.value.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 30
                    });
                }, 500);
            }
        );
        onUnmounted(() => {
            inboxactionMessageareaStore.events = [];
        });

        const handleSubmit = () => {

            const eventPromises = [];
            for (const eventaction of inboxactionMessageareaStore.events) {
                const tmpFunction = () => {
                    return new Promise(resolve => {

                        const formData = new FormData(messageRef.value);
                        const extra_data = {};
                        extra_data.content = formData.get("content");
                        if (eventaction.action_type === "forwardmessage") {
                            extra_data.email = formData.get("email");
                            extra_data.name = item.value.data.sender_name;
                        }
                        postInboxeventaction(eventaction.id, item.value.data.id, extra_data).then(result => {
                            resolve(result);
                        });
                    });
                };
                eventPromises.push(tmpFunction);
            }
            Promise.all(eventPromises.map(func => func())).then(result => {
                inboxactionMessageareaStore.events = [];
                addNotification(trans("Uw bericht wordt verzonden") + "...", 3500);
            });
        };

        return {
            trans,

            inboxStore,
            inboxactionStore,
            routeData,

            messageRef,
            messageFields,
            messageValues,

            inboxactionMessageareaStore,
            isForward,
            isReply,

            handleSubmit
        }
    }
});

</script>
